export const ACTIVITY_DISPLAY_TYPE_ORDER = ['workout', 'meal', 'media', 'metric', 'survey', 'other'];

function timestampOrInfinity(value) {
  if (!value) return Infinity;
  const timestamp = new Date(value).getTime();
  return Number.isFinite(timestamp) ? timestamp : Infinity;
}

function planOrder(activity) {
  const order = activity?.source?.plan_order;
  if (order === undefined || order === null || order === '') return null;
  const numericOrder = Number(order);
  return Number.isFinite(numericOrder) ? numericOrder : null;
}

export function compareActivitiesForDisplay(type, a, b) {
  const aDue = timestampOrInfinity(a?.due_at);
  const bDue = timestampOrInfinity(b?.due_at);

  // Workout urgency is the primary product rule. Completion changes the row's
  // presentation, not its position relative to later-expiring workouts.
  if (type === 'workout' && aDue !== bDue) return aDue - bDue;

  const aPlanOrder = planOrder(a);
  const bPlanOrder = planOrder(b);
  if (aPlanOrder !== null && bPlanOrder !== null && aPlanOrder !== bPlanOrder) {
    return aPlanOrder - bPlanOrder;
  }
  if (aPlanOrder !== null && bPlanOrder === null) return -1;
  if (aPlanOrder === null && bPlanOrder !== null) return 1;

  if (type !== 'workout' && aDue !== bDue) return aDue - bDue;

  const aCreated = timestampOrInfinity(a?.created_at);
  const bCreated = timestampOrInfinity(b?.created_at);
  if (aCreated !== bCreated) return aCreated - bCreated;

  return String(a?._virtualId || a?._id || '').localeCompare(String(b?._virtualId || b?._id || ''));
}

export function flattenActivitiesForDisplay(types = {}, predicate = () => true) {
  const knownTypes = ACTIVITY_DISPLAY_TYPE_ORDER.filter(type => Array.isArray(types[type]));
  const extraTypes = Object.keys(types)
    .filter(type => !ACTIVITY_DISPLAY_TYPE_ORDER.includes(type) && Array.isArray(types[type]))
    .sort();

  return [...knownTypes, ...extraTypes].flatMap(type =>
    [...types[type]]
      .sort((a, b) => compareActivitiesForDisplay(type, a, b))
      .filter(predicate)
  );
}
